/* eslint-disable no-unused-vars */
import axios from 'axios';
import { baseUrl } from '../../constants/config';
import { requestTypes } from '../../constants/enums/API';
import { jwtToken, logOut } from '../Auth/auth';

const request = async ({
  url,
  params,
  body,
  type = requestTypes.get,
  setLoading = () => {},
  disableLogOut = false,
}) => {
  setLoading(true);
  try {
    let response;

    const finalUrl = `${baseUrl}${url}`;
    console.log(finalUrl);
    const headers = {
      Authorization: `Bearer ${jwtToken}`,
    };

    switch (type.toUpperCase()) {
      case requestTypes.post:
        response = await axios.post(finalUrl, body, { params, headers });
        break;
      case requestTypes.put:
        response = await axios.put(finalUrl, body, { headers });
        break;
      case requestTypes.delete:
        response = await axios.delete(finalUrl, { data: body, headers });
        break;
      case requestTypes.get:
      default:
        response = await axios.get(finalUrl, { params, headers });
        break;
    }

    return response.data;
  } catch (error) {
    console.error('API request failed:', error);
    if (!disableLogOut) logOut();
  } finally {
    setLoading(false);
  }
};

export default request;
